import { useQuery } from '@tanstack/react-query';
import { SecureLinkType } from '@/types/myVaultTypes';
import { loadSecureLinkVerification, MY_VAULT_QUERY_KEYS } from '../../api/api';
import { IdVerificationRecordDialog } from '@/bundle/shared/components/IdVerificationRecordDialog/IdVerificationRecordDialog';

type VerificationRecordModalType = {
  isOpen: boolean;
  link: SecureLinkType;
  onClose: () => void;
};

export const VerificationRecordModal = ({ isOpen, link, onClose }: VerificationRecordModalType) => {
  const { data, isPending } = useQuery({
    queryKey: [MY_VAULT_QUERY_KEYS.verification, link.id],
    queryFn: () => loadSecureLinkVerification(link.id),
  });
  const record = data?.body;

  return <IdVerificationRecordDialog isOpen={isOpen} onClose={onClose} record={record} isLoading={isPending} />;
};
